export default [
  {
    title: "Нейтральные",
    color: "#b3bccc",
    name: "neutral"
  },
  {
    title: "Негативные",
    color: "#f75b5b",
    name: "negative"
  },
  {
    title: "Позитивные",
    color: "#15cf49",
    name: "positive"
  }
]
